import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getMessageFromError } from '@/core';
import { useAuditorVisitDetailContext } from '../contexts/AuditorVisitDetailContext';
import Form from './Form';
import { useDetailPageStore } from '../pages/detail-page/useDetailPageStore';
import { updateAuditorVisitById } from '../api/updateAuditorVisit';

const Details = () => {
  const { t } = useTranslation();
  const { auditorVisit } = useAuditorVisitDetailContext();

  const detailPageStore = useDetailPageStore();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const { mutate } = useMutation({
    mutationFn: updateAuditorVisitById,
    onSuccess: () => {
      enqueueSnackbar(
        t('Successfully saved changes.', { defaultValue: 'Successfully saved changes.' }),
        { variant: 'success' }
      );
      queryClient.invalidateQueries(['auditor-visit-id', auditorVisit.id]);
      navigate('/auditor-visits');
    },
    onError: (error: Error) => {
      enqueueSnackbar(getMessageFromError(error), { variant: 'error' });
    },
  });

  useEffect(() => {
    detailPageStore.setForm({ datEnd: auditorVisit.datEnd, datStart: auditorVisit.datStart });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auditorVisit]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Form
        onSubmit={(data) =>
          mutate({
            visitId: auditorVisit.id,
            data: {
              datStart: data.datStart || '',
              datEnd: data.datEnd || '',
            },
          })
        }
        visit={auditorVisit}
        initialState={detailPageStore.form}
        onUnmount={(form) => detailPageStore.setForm({ ...form })}
        isFormEditable
      />
    </Box>
  );
};

export default Details;
